import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SummarizeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"summarize"}/>
}
